import config from '@/config';
import axiosInstance from '@/school-management/utils/api';
import {
  BulkService,
  MoveDestinationsResponse,
  MoveStudentsResponse,
  BulkDeleteGroupsRequest,
  BulkDeleteGroupsResponse,
  BulkOperationResponse,
  DeleteStudentsResponse,
  ChangeStudentsLevelResponse,
} from '@/school-management/types/services/bulk';

export const bulkService: BulkService = {
  async getMoveClassDestinations(organizationId: string): Promise<MoveDestinationsResponse> {
    const url = `/admin-management/${config.apiVersion}/${organizationId}/students/move-destinations`;
    return axiosInstance.get(url);
  },
  async moveStudents(
    organizationId: string,
    studentIds: string[],
    destinationGroupId: string
  ): Promise<MoveStudentsResponse> {
    const url = `/admin-management/${config.apiVersion}/${organizationId}/students/bulk-move`;
    return axiosInstance.post(url, {
      studentIds: studentIds,
      destinationGroupId: destinationGroupId,
    });
  },
  async bulkDeleteGroups(
    organizationId: string,
    payload: BulkDeleteGroupsRequest
  ): Promise<BulkDeleteGroupsResponse> {
    const url = `/admin-management/${config.apiVersion}/${organizationId}/groups/bulk-delete`;
    return axiosInstance.post(url, payload);
  },
  async getBulkOperation(
    organizationId: string,
    operationId: string
  ): Promise<BulkOperationResponse> {
    const url = `/admin-management/${config.apiVersion}/${organizationId}/bulk-operations/${operationId}`;
    return axiosInstance.get(url);
  },
  async deleteStudents(
    organizationId: string,
    studentIds: string[],
    reason: string
  ): Promise<DeleteStudentsResponse> {
    const url = `/admin-management/${config.apiVersion}/${organizationId}/students/bulk-delete`;
    return axiosInstance.post(url, {
      studentIds: studentIds,
      reason: reason,
    });
  },
  async changeStudentsLevel(
    organizationId: string,
    studentIds: string[],
    newLevel: string
  ): Promise<ChangeStudentsLevelResponse> {
    const url = `/admin-management/${config.apiVersion}/${organizationId}/students/bulk-change-level`;
    return axiosInstance.post(url, {
      studentIds: studentIds,
      newLevel: newLevel,
    });
  },
};
